<template>
  <DpplTooltip
    tooltip-placement="top"
    :tooltip-offset="8"
    max-width="175px"
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <span
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      >
        <slot name="activator" />
      </span>
    </template>
    <template #tooltip-content>
      <div class="editor-toolbar-tooltip">
        <span class="editor-toolbar-tooltip-title-text">
          {{ title }}
        </span>
        <div
          v-if="shortcuts.length"
          class="editor-toolbar-tooltip-shortcuts"
        >
          <span
            v-for="shortcut in shortcuts"
            :key="shortcut"
            class="editor-toolbar-tooltip-shortcut-text ma-1"
          >{{ shortcut }}</span>
        </div>
      </div>
    </template>
  </DpplTooltip>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  shortcuts: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="less" scoped>
.editor-toolbar-tooltip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.editor-toolbar-tooltip-title-text {
  font-weight: 500;
  color: @text-darkest;
}

.editor-toolbar-tooltip-shortcuts {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin: -4px 0px;
}

.editor-toolbar-tooltip-shortcut-text {
  font-weight: 300;
  font-size: 12px;
  border-radius: 4px;
  background-color: fade(@text-darkest, 3%);
  color: fade(@text-darkest, 60%);
  padding: 2px;
}
</style>
